export class PersonNotificationParam
{
    primaryId: any;
    appCode: string;
    selected: any[] = [];
    toAdd: any[] = [];
    toDelete: any[] = [];
}
